<template>
	<div class="justify-content-center">
		<div :ref="stockCode" class="ht-100 ht-sm-50"></div>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.createChart()
		},
		data() {
			return {
				error: null,
			}
		},
		methods: {
			createChart() {
				const min = _.minBy(this.performance, (data) => data.market_price)
				const max = _.maxBy(this.performance, (data) => data.market_price)
				const data = _.map(this.performance, ({ market_price }, index) => [index, market_price])

				if (typeof min !== 'undefined' || typeof max !== 'undefined') {
					$.plot(
						this.$refs[this.stockCode],
						[
							{
								data,
								color: '#002856',
								lines: { lineWidth: 1 },
							},
						],
						{
							series: {
								stack: 0,
								shadowSize: 0,
								lines: {
									show: true,
									lineWidth: 1.5,
									fill: true,
									fillColor: { colors: [{ opacity: 0 }, { opacity: 0.2 }] },
								},
							},
							grid: {
								borderWidth: 0,
								hoverable: true,
								clickable: true,
								tooltip: true,
							},
							yaxis: { show: false },
							xaxis: {
								show: false,
								min: min.market_price,
								max: max.market_price,
							},
							zoom: {
								interactive: true,
							},
							pan: {
								interactive: true,
								enableTouch: true,
							},
						}
					)
				}
			},
		},
		props: ['stockCode', 'performance'],
	}
</script>

<style>
</style>
